export default __webpack_public_path__ + "static/media/tv.57ef8775.svg";